import React from 'react';
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import BarChartIcon from '@mui/icons-material/BarChart';
import StorageIcon from '@mui/icons-material/Storage';
import HandshakeIcon from '@mui/icons-material/Handshake';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const MethodologySection = () => {
  const { t } = useTranslation();
  const { lng } = useParams();

  const accordions = [
    {
      icon: <BarChartIcon sx={{ fontSize: '1.1rem', color: '#1E3A5F' }} />,
      title: t('methodology.scoring.title'),
      content: (
        <>
          <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>
            {t('methodology.scoring.intro')}
          </Typography>
          <Box component="ul" sx={{ pl: 2, color: 'text.secondary', '& li': { mb: 0.5 } }}>
            <li><Typography variant="body2"><strong>{t('methodology.scoring.pillar1')}</strong> - {t('methodology.scoring.pillar1Desc')}</Typography></li>
            <li><Typography variant="body2"><strong>{t('methodology.scoring.pillar2')}</strong> - {t('methodology.scoring.pillar2Desc')}</Typography></li>
            <li><Typography variant="body2"><strong>{t('methodology.scoring.pillar3')}</strong> - {t('methodology.scoring.pillar3Desc')}</Typography></li>
            <li><Typography variant="body2"><strong>{t('methodology.scoring.pillar4')}</strong> - {t('methodology.scoring.pillar4Desc')}</Typography></li>
            <li><Typography variant="body2"><strong>{t('methodology.scoring.pillar5')}</strong> - {t('methodology.scoring.pillar5Desc')}</Typography></li>
          </Box>
          <Typography variant="body2" sx={{ color: 'text.secondary', mt: 1 }}>
            {t('methodology.scoring.footer')}
          </Typography>
        </>
      ),
    },
    {
      icon: <StorageIcon sx={{ fontSize: '1.1rem', color: '#1E3A5F' }} />,
      title: t('methodology.dataSources.title'),
      content: (
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {t('methodology.dataSources.text')}
        </Typography>
      ),
    },
    {
      icon: <HandshakeIcon sx={{ fontSize: '1.1rem', color: '#1E3A5F' }} />,
      title: t('methodology.affiliateDisclosure.title'),
      content: (
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {t('methodology.affiliateDisclosure.text')}{' '}
          <Link to={`/${lng}/como-monetizamos`} style={{ color: 'inherit', fontWeight: 600 }}>
            {t('methodology.affiliateDisclosure.link')}
          </Link>.
        </Typography>
      ),
    },
  ];

  return (
    <Box
      sx={{
        bgcolor: '#f4f6f9',
        borderRadius: '14px',
        p: { xs: 3, md: 4 },
        my: 5,
      }}
    >
      <Typography
        variant="h6"
        sx={{ fontWeight: 700, color: 'text.primary', mb: 2.5 }}
      >
        {t('methodology.title')}
      </Typography>

      {accordions.map((item, i) => (
        <Accordion
          key={i}
          elevation={0}
          sx={{
            bgcolor: '#FFFFFF',
            '&:before': { display: 'none' },
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: '10px !important',
            mb: i < accordions.length - 1 ? 1 : 0,
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              {item.icon}
              <Typography variant="subtitle2" sx={{ fontWeight: 600, color: 'text.primary' }}>
                {item.title}
              </Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            {item.content}
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default MethodologySection;
